import React, { useContext, useEffect } from 'react'
import { FormattedMessage } from 'react-intl'
import { Grid, makeStyles } from '@material-ui/core'
import Button from '../../components/button/Button'
import { useSelector } from 'react-redux'
import { RootState } from '../reducers'
import { ContractsModel } from '../../types/contracts/contractsModel'
import { phaseEnum } from '../../enums/phaseEnum'
import { propertyType } from '../../enums/contractsEnum'
import { WHITE } from '../../theme'
import styles from '../../styles'
import { Theme } from '@material-ui/core/styles/createMuiTheme'
import { ResponsiveContext } from '../../utils/context/responsiveContext'
import linksEnum from '../../enums/linksEnum'
import { useHistory } from 'react-router-dom'
import { typeCandidatureEnum } from './enums/changementAppartementEnum'
import portals from '../../enums/portalsEnum'

const useStyles = makeStyles<Theme, { isTabletteScreen: boolean }>(
	(theme) => (
		{
			conteneurChangementAppartement: {
				backgroundColor: theme.palette.blue.main,
				padding: '20px 15px',
				marginTop: 20
			},
			conteneurTitre: {
				...styles(theme).title6,
				fontSize: props => props.isTabletteScreen ? 28 : 24,
				color: WHITE,
				textAlign: 'center',
				marginTop: 0
			},
			conteneurSousTitre: {
				...styles(theme).text8,
				color: WHITE,
				marginBottom: 30
			}
		}
	)
)

const ChangementAppartement = () => {
	const { isTabletteScreen } = useContext(ResponsiveContext)
	const classes = useStyles({ isTabletteScreen })
	const history = useHistory()

	useEffect(
		() => {
			if (process.env.REACT_APP_TARGET === portals.campus) {
				history.push(linksEnum.requests)
			}
		}, [history]
	)

	const contracts = useSelector((state: RootState) => state.contracts) as Partial<ContractsModel>[]

	// On récupère les contrats en phase d'exploitation et de type "appartement"
	const afficherChangerAppartement = contracts.filter((contract) => contract.phase === phaseEnum.exploitation && contract.type === propertyType.apartment).length > 0
	// On récupère les contrats en phase d'exploitation et de type "parking"
	const afficherChangerParking = contracts.filter((contract) => contract.phase === phaseEnum.exploitation && contract.type === propertyType.garage).length > 0

	const tailleBloc = () => {
		// S'il n'y a pas de contrat en exploitation de type appartement ET parking, on affiche que 2 boutons, donc on augmente la taille du bloc
		if (!afficherChangerAppartement && !afficherChangerParking) {
			return 6
		}

		// S'il n'y a pas de contrat en exploitation de type appartement OU parking, on affiche 3 boutons, on adapte donc la taille du bloc
		if (!afficherChangerAppartement || !afficherChangerParking) {
			return 4
		}

		// S'il y a des contrats en exploitation de type appartement et parking, on affiche 4 boutons, on réduit la taille du bloc
		return 3
	}

	const redirectionVersFormulaire = (typeDemande: typeCandidatureEnum) => {
		window.scrollTo(0, 0)
		history.push(linksEnum.formulaireChangementAppartement, { typeDemande })
	}

	return (
		<Grid container item xs={12} justify="center" className={classes.conteneurChangementAppartement}>
			<Grid container item xs={12} md={9} justify="center">
				<h2 className={classes.conteneurTitre}>
					<FormattedMessage
						id="changementAppartement.titre"
						defaultMessage="Vous souhaitez changer votre location ou ajouter une autre ?"
						description="Titre du changement d'appartement"
					/>
				</h2>
			</Grid>

			<Grid container item xs={12} justify="center">
				<p className={classes.conteneurSousTitre}>
					<FormattedMessage
						id="changementAppartement.sousTitre"
						defaultMessage="Dites-nous en plus sur votre besoin"
						description="Sous titre du changement d'appartement"
					/>
				</p>
			</Grid>

			<Grid container item xs={12} spacing={3}>
				{
					afficherChangerAppartement && (
						<Grid container item xs={12} sm={6} md={tailleBloc()}>
							<Button background="backgroundGreen" color="colorWhite" textStyle="text8" onClick={() => redirectionVersFormulaire(typeCandidatureEnum.changementAppartement)}>
								<FormattedMessage
									id="changementAppartement.changerAppartement"
									defaultMessage="Changer d'appartement"
									description="Bouton changer d'appartement"
								/>
							</Button>
						</Grid>
					)
				}

				<Grid container item xs={12} sm={6} md={tailleBloc()}>
					<Button background="backgroundGreen" color="colorWhite" textStyle="text8" onClick={() => redirectionVersFormulaire(typeCandidatureEnum.ajoutAppartement)}>
						<FormattedMessage
							id="changementAppartement.ajouterAppartement"
							defaultMessage="Ajouter un appartement"
							description="Bouton ajouter un appartement"
						/>
					</Button>
				</Grid>

				{
					afficherChangerParking && (
						<Grid container item xs={12} sm={6} md={tailleBloc()}>
							<Button background="backgroundGreen" color="colorWhite" textStyle="text8" onClick={() => redirectionVersFormulaire(typeCandidatureEnum.changementParking)}>
								<FormattedMessage
									id="changementAppartement.changerParking"
									defaultMessage="Changer de parking"
									description="Bouton changer de parking"
								/>
							</Button>
						</Grid>
					)
				}

				<Grid container item xs={12} sm={6} md={tailleBloc()}>
					<Button background="backgroundGreen" color="colorWhite" textStyle="text8" onClick={() => redirectionVersFormulaire(typeCandidatureEnum.ajoutParking)}>
						<FormattedMessage
							id="changementAppartement.ajouterParking"
							defaultMessage="Ajouter un parking"
							description="Bouton ajouter un parking"
						/>
					</Button>
				</Grid>
			</Grid>
		</Grid>
	)
}

export default ChangementAppartement
